import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface ScrollInstructionProps {
  currentSection: number;
  hasCompletedAllSections: boolean;
  totalSections: number;
}

const ScrollInstruction = ({
  currentSection,
  hasCompletedAllSections,
  totalSections,
}: ScrollInstructionProps) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const instructionData =
    labels.menuPages?.howItWorks?.overviewSection?.scrollInstruction || {};

  if (totalSections === 0) return null;

  const continueText =
    instructionData.continue ||
    (language === "en" ? "Scroll to continue" : "Scrolla för att fortsätta");
  const nextText =
    instructionData.nextSection ||
    (language === "en"
      ? "Scroll to see next section"
      : "Scrolla för att se nästa sektion");

  return (
    <motion.div
      className="text-center mt-6 md:mt-8 text-gray-600"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1 }}
    >
      <p className="text-xs sm:text-sm">
        {hasCompletedAllSections
          ? continueText
          : nextText
              .replace("{current}", String(currentSection + 1))
              .replace("{total}", String(totalSections))}
      </p>
    </motion.div>
  );
};

export default ScrollInstruction;
